import React, { useState } from "react";
import { Button } from "./ui/button";
import { Phone, Menu, X } from "lucide-react";
import { contactInfo } from "../data/mock";
import headerImage from "../images/KTTLOGO.jpeg";
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "Fleet", href: "#fleet" },
    { name: "Services", href: "#services" },
    { name: "Destinations", href: "#destinations" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#home" className="flex items-center gap-2">
              <div className="w-16 h-16 from-amber-500 to-amber-600 rounded-lg flex items-center justify-center overflow-hidden">
                <img
                  src={headerImage}
                  alt="Khoushik Tours & Travels Logo"
                  className="w-full h-full object-contain"
                  style={{ backgroundImage: "none" }}
                />
              </div>
              <div className="hidden sm:block">
                <h1 className="text-lg font-bold text-slate-800 leading-tight">
                  Khoushik
                </h1>
                <p className="text-xs text-slate-500 -mt-0.5">
                  Tours & Travels
                </p>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-slate-600 hover:text-amber-600 font-medium transition-colors duration-200"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a
              href={`tel:${contactInfo.phone1}`}
              className="flex items-center gap-2 text-slate-600 hover:text-amber-600 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">{contactInfo.phone1}</span>
            </a>
            <a
              href={`tel:${contactInfo.phone2}`}
              className="flex items-center gap-2 text-slate-600 hover:text-amber-600 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">{contactInfo.phone2}</span>
            </a>
            <Button className="bg-amber-500 hover:bg-amber-600 text-white px-6">
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-slate-600 hover:text-amber-600 transition-colors"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-100">
            <nav className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-slate-600 hover:text-amber-600 font-medium transition-colors py-2"
                >
                  {link.name}
                </a>
              ))}
              <a
                href={`tel:${contactInfo.phone1}`}
                className="flex items-center gap-2 text-slate-600 py-2"
              >
                <Phone className="w-4 h-4" />
                <span className="font-medium">{contactInfo.phone1}</span>
              </a>
              <a
                href={`tel:${contactInfo.phone2}`}
                className="flex items-center gap-2 text-slate-600 py-2"
              >
                <Phone className="w-4 h-4" />
                <span className="font-medium">{contactInfo.phone2}</span>
              </a>
              <Button className="bg-amber-500 hover:bg-amber-600 text-white w-full mt-2">
                Book Now
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
